import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { useAccessDeniedStore } from "../../stores/Modal/AccessDeniedStore";

import CountUp from "react-countup";

//Import Icons
import FeatherIcon from "feather-icons-react";
import {
  CustomDataLabel,
  DeliveredOrdersChart,
  DeliveryTimeChart,
  YAxis,
  WeeklyVisitsChart,
  TopSpacesChart,
  ResponseTimeChart,
  WeeklyResponseTimeChart,
} from "./charts";
import BreadCrumb from "./Breadcrumb";
import Section from "./Breadcrumb";
import { useDashboardStore } from "../../stores/Dashboard";
import { useTranslation } from "react-i18next";
import { useSiteStore } from "../../stores/Assets/site";
import { timeConversion } from "../../Components/Common/timeConversion";
const Dashboard = () => {
  const { t } = useTranslation();
  const location = useLocation();
  document.title = t("Clickorder Admin");

  const { show } = useAccessDeniedStore();

  useEffect(() => {
    if (location.state?.accessDenied) {
      show();
      // Clear the state so it doesn't show again on reload
      window.history.replaceState({}, document.title);
    }
  }, [location.state, show]);
  const [selectedSiteIds, setSelectedSiteIds] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [siteList, setSiteList] = useState([]);
  const {
    dailyStats,
    weeklyServices,
    weeklyOrders,
    isLoading,
    fetchStats,
    dailyServiceStats,
    visitDaily,
    visitWeekly,
    visitSpaces,
    visitKitchens,
    responseTimeStats,
    weeklyResponseTime,
  } = useDashboardStore((state) => state);
  const { getSites, sites } = useSiteStore((state) => state);
  const getDailyReport = async () => {
    fetchStats(selectedSiteIds, selectedDate); // Fetch data when site or date changes
  };
  useEffect(() => {
    getDailyReport(selectedSiteIds, selectedDate);
  }, []);

  useEffect(() => {
    const fetchSites = async () => {
      const list = await getSites(); // Fetch sites
      const formattedOptions = list?.map((site) => {
        return {
          label: `${site.site_id}-${site.name}`,
          value: site.site_id,
        };
      });
      setSiteList(formattedOptions);
    };

    fetchSites(); // Call the fetch function
  }, [getSites]);
  useEffect(() => {
    const formattedOptions = sites?.map((site) => {
      return {
        label: `${site.site_id}-${site.name}`,
        value: site.site_id,
      };
    });
    setSiteList(formattedOptions);
  }, [sites]);

  const counterWidgets = [
    {
      id: 1,
      label: t("Total Delivered Items"),
      labelClass: "muted",

      counter: dailyStats?.order_count,
      caption: `${t("From")} ${visitDaily?.total_visits || 0} ${t("Menu Visits")}`,
      captionisLink: true,
      icon: "ri-shopping-bag-line",
      iconClass: "soft-success",
      color: "success",
      decimals: 0,
      suffix: ` ${dailyStats?.order_count > 1 ? t("Items") : t("Item")}`,
    },
  ];
  const stringWidgets = [
    {
      id: 1,
      label: t("Avg. DELIVERY TIME"),
      labelClass: "muted",
      top: timeConversion(dailyStats?.average_delivery_time || 0),
      caption: t("Based on delivered orders"),
      captionisLink: false,

      captionClass: "muted",
      icon: "ri-timer-line",
      iconClass: "soft-secondary",
      color: "secondary",
      decimals: 1,
      suffix: ` ${t("min")}`,
    },
    {
      id: 1,
      label: "",
      labelClass: "muted",
      label: t("TOP ORDERED ITEM"),
      top: dailyStats?.top_service?.item || "--",
      caption: `${t("Ordered")} ${dailyStats?.top_service?.order_count || 0} ${t("times")}`,
      captionisLink: false,
      captionClass: "muted",

      icon: "ri-funds-box-line",
      iconClass: "soft-info",
      color: "info",
      decimals: 0,
      suffix: ` ${t("min")}`,
    },
    {
      id: 1,
      label: t("TOP ORDERING SPACE"),
      labelClass: "muted",
      top: dailyStats?.top_space?.name || "--",
      caption: `${t("Ordered")} ${dailyStats?.top_space?.order_count || 0} ${t("times")}`,
      captionisLink: false,
      captionClass: "muted",
      icon: "ri-road-map-line",
      iconClass: "soft-primary",
      color: "primary",
      decimals: 0,
      suffix: ` ${t("Orders")}`,
    },
  ];

  // if (isLoading) return <div>Loading...</div>; // Show loading state while fetching data

  return (
    <React.Fragment>
      <Container fluid>
        <Section
          getDailyReport={getDailyReport}
          setSelectedDate={setSelectedDate}
          selectedSiteIds={selectedSiteIds}
          setSelectedSiteIds={setSelectedSiteIds}
          siteList={siteList}
        />
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <Row>
              {(counterWidgets || []).map((item, key) => (
                <Col xl={3} md={6} key={key}>
                  <Card className={"card-animate"}>
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <p
                            className={
                              "text-uppercase fw-medium mb-0 text-" +
                              item.labelClass
                            }
                          >
                            {item.label}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-end justify-content-between mt-4">
                        <div>
                          <h4
                            className={
                              "fs-22 fw-semibold ff-secondary mb-4 " +
                              item.counterClass
                            }
                          >
                            <span
                              className="counter-value"
                              data-target="559.25"
                            >
                              <CountUp
                                start={0}
                                // prefix={item.prefix}
                                suffix={item.suffix}
                                separator={item.separator}
                                end={item.counter}
                                duration={4}
                              />
                            </span>
                          </h4>

                          <p className={`${item.captionisLink ? "text-decoration-underline text-success cursor-pointer" : ""} mb-0 text-` + item.captionClass}>
                            {item.caption}
                          </p>

                        </div>
                        <div className="avatar-sm flex-shrink-0">
                          <span
                            className={
                              "avatar-title rounded fs-3 bg-" + item.iconClass
                            }
                          >
                            <i
                              className={item.icon + " text-" + item.color}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
              {(stringWidgets || []).map((item, key) => (
                <Col xl={3} md={6} key={key}>
                  <Card className={"card-animate"}>
                    <CardBody>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <p
                            className={
                              "text-uppercase fw-medium mb-0 text-" +
                              item.labelClass
                            }
                          >
                            {item.label}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-end justify-content-between mt-4">
                        <div>
                          <h4
                            className={
                              "fs-22 fw-semibold ff-secondary mb-4 " +
                              item.counterClass
                            }
                          >
                            <span>{item.top}</span>
                          </h4>
                          {item.captionisLink ? (
                            <Link
                              to="#"
                              className={
                                "text-decoration-underline " + item.captionClass
                              }
                            >
                              {item.caption}
                            </Link>
                          ) : (
                            <p className={"mb-0 text-" + item.captionClass}>
                              {item.caption}
                            </p>
                          )}
                        </div>
                        <div className="avatar-sm flex-shrink-0">
                          <span
                            className={
                              "avatar-title rounded fs-3 bg-" + item.iconClass
                            }
                          >
                            <i
                              className={item.icon + " text-" + item.color}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <Row>
              <Col lg={6}>
                <Card>
                  <CardHeader>
                    <h4 className="card-title mb-0">
                      {t("Service Stations - Delivered Items")}
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <DeliveredOrdersChart
                      dailyStats={dailyServiceStats}
                      visitKitchens={visitKitchens}
                      dataColors='["#FFD85D", "#ce9558", "#67CBBD"  ]'
                    />
                  </CardBody>
                </Card>
              </Col>

              <Col lg={6}>
                <Card>
                  <CardHeader>
                    <h4 className="card-title mb-0">
                      {t("Service Stations - Delivery Time")}
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <DeliveryTimeChart
                      dailyStats={dailyServiceStats}
                      visitKitchens={visitKitchens}
                      dataColors='["--vz-success","#ce9558" , "--vz-danger", "--vz-dark", "--vz-primary", "--vz-success", "--vz-secondary"]'
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <div className="">
              <h3>{t("Some insights from last week")}</h3>
              <p>{t("Here is what happend in the last 7 days.")}</p>
            </div>
            <Row>
              <Col lg={6}>
                <Card>
                  <CardHeader>
                    <h4 className="card-title mb-0">
                      {t("Weekly Total Orders and Visits")}

                    </h4>
                  </CardHeader>
                  <CardBody>
                    <YAxis
                      weeklyOrders={weeklyOrders}
                      weeklyVisits={visitWeekly}
                      dataColors='["#FFD85D", "#ce9558", "#67CBBD"  ]'
                    />
                  </CardBody>
                </Card>
              </Col>

              <Col lg={6}>
                <Card>
                  <CardHeader>
                    <h4 className="card-title mb-0">
                      {t("Weekly Top 10 Ordered Items")}
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <CustomDataLabel
                      weeklyServices={weeklyServices}
                      dataColors='["--vz-primary", "--vz-secondary", "--vz-success", "--vz-info", "--vz-warning", "--vz-danger", "--vz-dark", "--vz-primary", "--vz-success", "--vz-secondary"]'
                    />
                  </CardBody>
                </Card>
              </Col>

              {/* <Col lg={6}>
                <Card>
                  <CardHeader>
                    <h4 className="card-title mb-0">Weekly QR Scans Trend</h4>
                  </CardHeader>
                  <CardBody>
                    <WeeklyVisitsChart
                      visitWeekly={visitWeekly}
                      dataColors='["--vz-warning"]'
                    />
                  </CardBody>
                </Card>
              </Col> */}
            </Row>
            <div className="">
              <h3>{t("Staff response time")}</h3>
              <p>{t("Time from order to first staff action.")}</p>
            </div>
            <Row>
              <Col lg={6}>
                <Card>
                  <CardHeader>
                    <h4 className="card-title mb-0">
                      {t("Service Stations - Response Time")}
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <ResponseTimeChart
                      responseTimeStats={responseTimeStats}
                      dataColors='["--vz-success","#ce9558", "--vz-danger"]'
                    />
                  </CardBody>
                </Card>
              </Col>

              <Col lg={6}>
                <Card>
                  <CardHeader>
                    <h4 className="card-title mb-0">
                      {t("Weekly Response Time")}
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <WeeklyResponseTimeChart
                      weeklyResponseTime={weeklyResponseTime}
                      dataColors='["#ce9558", "--vz-danger"]'
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Container>
    </React.Fragment>
  );
};

export default Dashboard;
